import list from './list'
import create from './create'

export default {
  strict: true,
  namespaced: true,
  state: Object.assign(
    list.state,
    create.state
  ),
  mutations: Object.assign(
    list.mutations,
    create.mutations
  )
}



// WEBPACK FOOTER //
// ./src/store/flights/index.js